/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import '../../styles/components.css';
import { useAuth } from '../../contexts/AuthContext';

const FundRequest: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const { userProfile } = useAuth();
  const ngoId = userProfile?.ngo_id;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [project, setProject] = useState<any>(null);
  const [formData, setFormData] = useState({
    amount: '',
    purpose: '',
    tranche_number: '',
    attachments: [] as File[]
  });

  useEffect(() => {
    if (projectId) {
      loadProject();
    }
  }, [projectId]);

  const loadProject = async () => {
    if (!projectId) return;

    const { data, error } = await supabase
      .from('projects')
      .select('*')
      .eq('id', projectId)
      .single();

    if (!error && data) {
      setProject(data);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData(prev => ({
        ...prev,
        attachments: Array.from(e.target.files || [])
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user || !projectId || !ngoId) throw new Error('Not authenticated');

      // Upload attachments if any
      const attachmentUrls: string[] = [];
      if (formData.attachments.length > 0) {
        for (const file of formData.attachments) {
          const fileName = `${projectId}/${ngoId}/${Date.now()}_${file.name}`;
          const { error: uploadError } = await supabase.storage
            .from('fund-request-attachments')
            .upload(fileName, file);

          if (uploadError) throw uploadError;

          const { data: { publicUrl } } = supabase.storage
            .from('fund-request-attachments')
            .getPublicUrl(fileName);

          attachmentUrls.push(publicUrl);
        }
      }

      // Create fund request
      const { error: requestError } = await supabase
        .from('fund_requests')
        .insert({
          project_id: projectId,
          ngo_id: ngoId,
          amount: parseFloat(formData.amount),
          purpose: formData.purpose,
          attachments: attachmentUrls,
          status: 'pending',
          tranche_number: formData.tranche_number ? parseInt(formData.tranche_number) : null
        })
        .select()
        .single();

      if (requestError) throw requestError;

      navigate(`/ngo/ngo/finance`);
    } catch (err: any) {
      setError(err.message || 'Failed to create fund request');
    } finally {
      setLoading(false);
    }
  };

  if (!project) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="form-container">
      <div className="form-section">
        <h1>Request Fund Disbursement</h1>
        <p style={{ color: 'var(--muted)', marginBottom: '2rem' }}>
          Request funds for project: <strong>{project.name}</strong>
        </p>

        {error && (
          <div className="toast toast-error" style={{ position: 'relative', marginBottom: '1rem' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Amount (₹) *</label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
              required
              placeholder="Enter amount"
              step="0.01"
              min="0"
            />
          </div>

          <div className="form-group">
            <label>Purpose *</label>
            <textarea
              name="purpose"
              value={formData.purpose}
              onChange={(e) => setFormData({ ...formData, purpose: e.target.value })}
              required
              placeholder="Describe the purpose of this fund request..."
              rows={4}
            />
          </div>

          {project.tranche_plan && Array.isArray(project.tranche_plan) && project.tranche_plan.length > 0 && (
            <div className="form-group">
              <label>Tranche Number (if applicable)</label>
              <select
                name="tranche_number"
                value={formData.tranche_number}
                onChange={(e) => setFormData({ ...formData, tranche_number: e.target.value })}
              >
                <option value="">Select tranche</option>
                {project.tranche_plan.map((tranche: any, index: number) => (
                  <option key={index} value={tranche.tranche_number || index + 1}>
                    Tranche {tranche.tranche_number || index + 1} - ₹{parseFloat(tranche.amount || 0).toLocaleString('en-IN')}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>Attachments (Optional)</label>
            <input
              type="file"
              multiple
              onChange={handleFileChange}
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            />
            <div className="help-text">
              Upload supporting documents (PDF, DOC, images)
            </div>
            {formData.attachments.length > 0 && (
              <div style={{ marginTop: '0.5rem' }}>
                <strong>Selected files:</strong>
                <ul style={{ marginTop: '0.25rem', paddingLeft: '1.5rem' }}>
                  {formData.attachments.map((file, index) => (
                    <li key={index}>{file.name}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => navigate(`/ngo/ngo/finance`)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Submitting...' : 'Submit Request'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FundRequest;


